export const localtext = {
  DefaultErrorMessage: "The retry request could not be completed.",
  MissingRequestIdMessage: "Enter a request ID before retrying.",
  MissingRequestIdTitle: "Request ID required",
  RequestFailedTitle: "Retry failed",
  RequestId: "Request ID",
  RequestIdPlaceholder: "Enter request ID",
  RequestSubmittedTitle: "Retry submitted",
  Retry: "Retry",
  Subtitle:
    "Resubmit a request that is stuck in processing using its request ID.",
  TicketUrl: "Ticket URL",
  TicketUrlPlaceholder: "https://jira.example.com/browse/CDHX-12345",
  Title: "Retry Request",
} as const;
